// Behaviors
require("./behaviors/01.menu-mobile");
require("./behaviors/02.image-bg");
require("./behaviors/03.anchor-link");
require("./behaviors/04.fancybox");
require("./behaviors/05.slide");
// require('./behaviors/08.header-fixed');
require("./behaviors/09.carousel-products");
require("./behaviors/09.carousel-multiline-products");
// require('./behaviors/10.carousel-categories');
require("./behaviors/11.carousel-gallery-single-product");
require("./behaviors/12.carousel-testimony");
require("./behaviors/13.product-elements-checkbox");
require("./behaviors/20.masks");

jQuery(document).ready(function ($) {
    $('body').on('added_to_cart', function (e, data) {
        e.preventDefault();

        if (typeof fbq === 'function') {
            var url_cart_ajax = $('#modal-cart-added').data('url-cart-ajax');

            $.post(url_cart_ajax, {
                action: "jk_woo_cart"
            }, function (response) {
                var data = JSON.parse(response);

                fbq('track', 'AddToCart', { currency: data.currency, value: data.total });

                console.log('track AddToCart: ', data);
            });
        } else {
            console.log("function fbq() is not defined");
        }

        const modal = new bootstrap.Modal('#modal-cart-added', {
            backdrop: 'static',
        })
        modal.show();

        eventsModal(data['div.widget_shopping_cart_content']);
    });

    function eventsModal(data) {
        const modalCartAdded = document.getElementById('modal-cart-added')

        modalCartAdded.addEventListener('shown.bs.modal', event => {
            $('#modal-cart-content').html(data);
        })
    }
});